// consoles/peak/PeakConsole.js —— 削峰填谷控制台
// 严格依据《云平台单站控制（削峰填谷）需求文档》组织 tab 集合：
// 首页 / 主接线图（强电图 + 拓扑图两个子页） / 设备监控 / 故障告警 / 曲线报表 /
// 控制中心（二次口令） / 系统管理 / 设备读写（二次口令）
// 本类型独有：日前策略、DCDC / UPS / 消防安全、电池簇曲线；不得借用另外两份文档的模块。
import React, { useState } from 'react';
import ScrollTabs from '../../../../components/ScrollTabs';
import PeakHome from '../../panels/peak/PeakHome';
import PeakWiring from '../../panels/peak/PeakWiring';
import PeakDevice from '../../panels/peak/PeakDevice';
import PeakAlarm from '../../panels/peak/PeakAlarm';
import PeakCurve from '../../panels/peak/PeakCurve';
import PeakControl from '../../panels/peak/PeakControl';
import PeakSystem from '../../panels/peak/PeakSystem';
import PeakReadWrite from '../../panels/peak/PeakReadWrite';

const PeakConsole = ({ station, unlocked, gate, rwUnlocked, rwGate }) => {
  const [tab, setTab] = useState('home');

  const items = [
    { key: 'home', label: '首页', children: <PeakHome station={station} /> },
    { key: 'wiring', label: '主接线图', children: <PeakWiring station={station} /> },
    { key: 'device', label: '设备监控', children: <PeakDevice station={station} /> },
    { key: 'alarm', label: '故障告警', children: <PeakAlarm station={station} /> },
    { key: 'curve', label: '曲线报表', children: <PeakCurve station={station} /> },
    { key: 'control', label: '控制中心', children: unlocked ? <PeakControl station={station} /> : gate },
    { key: 'system', label: '系统管理', children: <PeakSystem station={station} /> },
    { key: 'readwrite', label: '设备读写', children: rwUnlocked ? <PeakReadWrite station={station} /> : rwGate },
  ];

  return (
    <div className="panel sm-tabs">
      <ScrollTabs activeKey={tab} onChange={setTab} items={items} />
    </div>
  );
};

export default PeakConsole;
